import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import CrudActionContainer from './CrudActionContainer';
import LandingPageController from '../controllers/LandingPageController';
import commonHandler from '../errorHandlers/common-handler';
import { selectLandingPage, unselectLandingPage } from './viewActions';
import LandingPageModel, {
  LandingPageCreateParams,
} from '../model/LandingPageModel';
import { StoreState } from '../store-interfaces';

type Create = (
  botId: number,
  entity: LandingPageCreateParams,
  fbPageId: number,
) => (dispatch: Dispatch<StoreState>) => Promise<LandingPageModel>;

type RetrieveAll = (
  botId: number,
) => (dispatch: Dispatch<StoreState>) => Promise<LandingPageModel[]>;

type RetrieveById = (
  botId: number,
  landingPageId: number,
) => (dispatch: Dispatch<StoreState>) => Promise<LandingPageModel[]>;

type Update = (
  botId: number,
  entity: LandingPageModel,
) => (dispatch: Dispatch<StoreState>) => Promise<LandingPageModel>;

type Delete = (
  botId: number,
  entity: LandingPageModel,
) => (dispatch: Dispatch<StoreState>) => Promise<{ succes: boolean }>;

class LandingPageCRUDActions extends CrudActionContainer {
  resetAction: string;

  constructor() {
    super('LANDING_PAGE');
    this.resetAction = super.makeActionKey('RESET');
  }

  create: Create = (botId, entity, fbPageId) => {
    return async dispatch => {
      try {
        dispatch(this.busy(this.createAction));
        const response = await LandingPageController.post(
          botId,
          entity,
          fbPageId,
        );
        dispatch(this.retrieved(response));
        dispatch(selectLandingPage(response));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  };

  retrieveAll: RetrieveAll = botId => {
    return async dispatch => {
      try {
        dispatch(this.busy(this.retrieveAllAction));
        const response = await LandingPageController.getAll(botId);
        dispatch(this.retrievedAll(response));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  };

  retrieveById: RetrieveById = (botId, landingPageId) => {
    return async dispatch => {
      try {
        const response = await LandingPageController.getById(
          botId,
          landingPageId,
        );
        dispatch(selectLandingPage(response));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  };

  update: Update = (botId, entity) => {
    return async dispatch => {
      try {
        dispatch(this.busy(this.updateAction));
        const response = await LandingPageController.put(botId, entity);
        dispatch(this.updateLocal(response));
        dispatch(selectLandingPage(response));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  };

  delete: Delete = (botId, entity) => {
    return async dispatch => {
      try {
        dispatch(this.busy(this.deleteLocalAction));
        dispatch(this.deleteLocal(entity));
        const response = await LandingPageController.delete(botId, entity.id);
        dispatch(this.retrieveAll(botId));
        dispatch(unselectLandingPage());
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  };

  reset() {
    return {
      type: this.resetAction,
    };
  }
}

const landingPageCRUDActions = new LandingPageCRUDActions();

export default landingPageCRUDActions;

export const useLandingPageCRUDActions = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  return {
    create: (
      botId: number,
      entity: LandingPageCreateParams,
      fbPageId: number,
    ) => dispatch(landingPageCRUDActions.create(botId, entity, fbPageId)),
    retrieveAll: (chatbotId: number) =>
      dispatch(landingPageCRUDActions.retrieveAll(chatbotId)),
  };
};
